import { FC } from 'react';

export type LayoutProps = {
  children: React.ReactNode;
};

const EmbedLayout: FC<LayoutProps> = ({ children }) => {
  return <main>{children}</main>;
};

export default EmbedLayout;
